import { useEffect, useState } from 'react';

/**
 *  Listen for the message window event sent by WP
 *
 *  Parameter: elementId - the id of the AdSlot
 *
 *  If the message event sends the elementId that matches the slot id of the ad you
 *  want to check, then that means the ad is flighted and you should display it for the
 *  superhero
 *
 */

function useWindowMessageEvent(elementId) {
    const [messageOptions, setMessageOptions] = useState({});

    const fullAdType = `div-gpt-ad-${elementId}`;

    useEffect(() => {
        const handler = (e) => {
            try {
                const msg = JSON.parse(e.data);

                if (msg && msg.elementId === elementId || msg.adType === fullAdType) {
                    setMessageOptions(msg.options);
                }
            } catch (error) {
                // do nothing
            }
        };

        window.addEventListener('message', handler);

        return () => window.removeEventListener('message', handler);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [messageOptions]);

    return messageOptions;
}

export default useWindowMessageEvent;
